import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const ScheduleFieldStyled = styled.div`
  /* margin: 5px 0px; */

  .label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .fields {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .width {
      width: 120px;
      border: 1px solid ${COLOUR_CONSTANT.theme.dark};
      border-radius: 5px;
      height: 39px;
      position: relative;
      opacity: ${(props) => (props.isTransparent ? "0.5" : "unset")};

      .minus {
        position: absolute;
        z-index: 100;
        top: -13px;
        right: -9px;
        cursor: pointer;
        cursor: pointer;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0.2s, opacity 0.2s;
      }

      &:hover .minus {
        visibility: visible;
        opacity: 1;
      }
    }

    .input-field {
      margin: 0px;
      fieldset {
        border: none !important;
      }
      .MuiInputBase-root {
        border-radius: 0px;
        height: 21px;
        padding: 8px !important;
      }
    }

    .month-label {
      height: 14px;
      background-color: ${COLOUR_CONSTANT.theme.purple.medium};
      display: flex;
      align-items: center;
      justify-content: center;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    }
  }

  .error {
    font-size: 11px;
    color: #d32f2f;
  }
  .MuiInputBase-root .MuiInputBase-input {
    text-align: center;
    padding-left: 0 !important;
  }
`;
